import {
  FETCH_CATALOG_FOR_OFFICE_REQUEST,
  FETCH_CATALOG_FOR_OFFICE_SUCCESS,
  FETCH_CATALOG_FOR_OFFICE_ERROR,
} from '../constants';

const initialState = {
  loading: false,
  data: null,
  error: false,
};

const servicesForOfficeReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CATALOG_FOR_OFFICE_REQUEST:
      return {
        ...initialState,
        loading: true,
      };
    case FETCH_CATALOG_FOR_OFFICE_SUCCESS:
      return {
        ...initialState,
        loading: false,
        data: action.payload,
      };
    case FETCH_CATALOG_FOR_OFFICE_ERROR:
      return {
        ...initialState,
        loading: false,
        error: true,
      };
    default:
      return state;
  }
};

export default servicesForOfficeReducer;
